module.exports = __webpack_public_path__ + "static/media/calendar-gray.29578665.svg";